import React, { useState, useEffect, useRef } from "react" ;
import axios from 'axios'
import PaypalCheckoutMain from "./PaypalCheckoutMain";

const PaypalCheckoutHSK4 = () => {
   
    return (
        <PaypalCheckoutMain
        amountTotal="35.00"
        hsk="_hsk4"
        hskNumber="4"
      />
    );
}

export default PaypalCheckoutHSK4